
import CancelarVenda from "../components/CancelarVenda";

const STATUS_COLOR = {
  aprovada: "green",
  rejeitado: "red",
  "aguardando cancelamento": "grey",
  cancelado: "grey darken-2",
};

export default {
  name: "VendaBlocoDeLista",
  props: {
    lista: Array,
    modo: { default: "analise", type: String },
    hasMore: { type: Boolean, default: false },
    loadingMais: { type: Boolean, default: false },
  },
  components: { CancelarVenda },
  methods: {
    dataFormatada(value) {
      const s = String(value || "");
      const head = s.split("T")[0].split(" ")[0];
      const [yyyy, mm, dd] = head.split("-");
      if (yyyy && mm && dd) return `${dd}/${mm}/${yyyy}`;
      try {
        return new Date(s).toLocaleDateString("pt-BR");
      } catch (e) {
        return s;
      }
    },
    corDoStatus(s) {
      const key = String(s || "").toLowerCase();
      return STATUS_COLOR[key] || "orange";
    },
    temValor(v) {
      return v != null && String(v).trim() !== "";
    },
    permissoesPorLinha(venda, modo) {
      const s = String((venda && venda.status) || "").toLowerCase();
      const base = ["aprovada", "aguardando cancelamento", "cancelado"];
      const isVendas = (modo || this.modo) === "vendas";
      const block = isVendas
        ? [
            ...base,
            "em análise",
            "em analise",
            "aguardando análise",
            "aguardando analise",
          ]
        : base;
      const podeEditarOuCancelar = !block.includes(s);
      const podeGerarLink = [
        "em análise",
        "em analise",
        "aguardando análise",
        "aguardando analise",
      ].includes(s);
      return {
        visualizar: true,
        editar: podeEditarOuCancelar,
        cancelar: podeEditarOuCancelar,
        gerarLink: podeGerarLink,
      };
    },
  },
};
